"use strict"; // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var common_1 = require("../common");

var MarkClass =
/*#__PURE__*/
function (_common_1$ObjectClass) {
  _inherits(MarkClass, _common_1$ObjectClass);

  function MarkClass() {
    _classCallCheck(this, MarkClass);

    return _possibleConstructorReturn(this, _getPrototypeOf(MarkClass).apply(this, arguments));
  }

  _createClass(MarkClass, [{
    key: "initializeState",

    /** Fill the default state */
    value: function initializeState() {}
    /** Get intrinsic constraints between attributes (e.g., x2 - x1 = width for rectangles) */

  }, {
    key: "buildConstraints",
    value: function buildConstraints(solver, context) {}
    /** Get the graphical element from the element */

  }, {
    key: "getGraphics",
    value: function getGraphics(coordinateSystem, offset, glyphIndex, manager, emphasized) {
      return null;
    }
    /** Get DropZones given current state */

  }, {
    key: "getDropZones",
    value: function getDropZones() {
      return [];
    }
    /** Get link anchors for this mark */

  }, {
    key: "getLinkAnchors",
    value: function getLinkAnchors(mode) {
      return [];
    }
    /** Get handles given current state */

  }, {
    key: "getHandles",
    value: function getHandles() {
      return [];
    }
    /** Get bounding box */

  }, {
    key: "getBoundingBox",
    value: function getBoundingBox() {
      return null;
    }
    /** Get alignment guides */

  }, {
    key: "getSnappingGuides",
    value: function getSnappingGuides() {
      return [];
    }
  }, {
    key: "getGlyphClass",
    value: function getGlyphClass() {
      return this.parent;
    }
  }, {
    key: "getPlotSegmentClass",
    value: function getPlotSegmentClass() {
      return this.parent.parent;
    }
  }, {
    key: "getChartClass",
    value: function getChartClass() {
      return this.parent.parent.parent;
    }
  }]);

  return MarkClass;
}(common_1.ObjectClass);

exports.MarkClass = MarkClass;